export default __webpack_public_path__ + "static/options-08597507318de24800a4f4cad19eacf0.png";